module.exports = __webpack_public_path__ + "static/img/img2.ca78b021.png";